import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import View from '@opsbase/lib-data-view/View';
import Pages from '@opsbase/lib-pages';
import useOpDefinitionFindById from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionFindById';
import useStaffFindById from '@opsbase/react-gql-hooks/staff/useStaffFindById';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import useNav from '@opsbase/web-nav/useNav';
import Spinner from '@opsbase/web-ui/Spinner';
import React, { useEffect } from 'react';
export function IssuesLogOpener(props) {
    const { dialog, opDefinitionId, createdBy, assignedTo, onComplete } = props;
    const { allissues } = useViewRegistry();
    const { putView } = useViewRegistryActions();
    const { goTo } = useNav();
    const { loading: loadingOpDef, data: opDef } = useOpDefinitionFindById({
        variables: { id: opDefinitionId },
        skip: !opDefinitionId,
    });
    const { loading: loadingStaff, data: staff } = useStaffFindById({
        variables: { id: createdBy || assignedTo },
        skip: !(createdBy || assignedTo),
    });
    useEffect(() => {
        if ((!opDefinitionId || (!loadingOpDef && !!opDef)) &&
            (!(createdBy || assignedTo) || (!loadingStaff && !!staff))) {
            // Create new LMSS
            const view = new View({
                id: 'issusfor' + (opDefinitionId || createdBy || assignedTo),
                title: allissues.title,
                type: allissues.type,
                fields: allissues.fields,
                groupBys: [],
                filters: [],
                sortBy: allissues.sortBy.key,
                sortByDesc: allissues.sortByDesc,
            });
            // If OpDef Log
            if (opDef) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.OPDEFINITION,
                    id: opDef.id,
                    title: opDef.title,
                    frozen: true,
                });
                view.groupBys.push({ queryFieldKey: QueryFieldKey.ISSUE_STATUS });
            }
            // If Created By
            if (!!createdBy) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.ISSUE_CREATEDBY,
                    id: staff.id,
                    title: staff.title,
                    frozen: true,
                });
            }
            // If Created By
            if (!!assignedTo) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.ISSUE_ASSIGNEDTO,
                    id: staff.id,
                    title: staff.title,
                    frozen: true,
                });
            }
            // Done
            putView(view, true);
            goTo(dialog ? Pages.ISSUES_LOG_DIALOG : Pages.ISSUES_LOG, { viewId: view.id });
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    }, [
        allissues,
        assignedTo,
        createdBy,
        dialog,
        goTo,
        loadingOpDef,
        loadingStaff,
        onComplete,
        opDef,
        opDefinitionId,
        putView,
        staff,
    ]);
    return React.createElement(Spinner, null);
}
export default IssuesLogOpener;
